<!-- One Issue, on every surface that shows one. The columns are the same everywhere and
     in the same order; a narrow surface drops the ones it has no room for rather than
     drawing the Issue a second way. The asset and its location are what a panel drops:
     inside one asset's screen both are already known, so they carry nothing. -->
<!-- The header: the same cells in the same order, each a sort button. A header is not a
     row, so it is a plain block rather than the row's button, and it never renders in a
     panel, where the surface has no sort. The page carries no grid around the rows, so the
     cells take no grid roles; the sorted button says its direction in words instead. -->
<div *ngIf="header" class="issue-fr issue-hdr">
  <span class="fr-sev">
    <button type="button" class="fr-hbtn" [class.sorted]="isSorted(IssueSortKeys.Severity)" [class.asc]="isSorted(IssueSortKeys.Severity) && sort?.dir === 'asc'"
            [disabled]="!sortEnabled"
            (click)="onSort(IssueSortKeys.Severity)"><span class="fr-hlabel">{{ '@severity' | translate }}</span><span class="fr-arrow" aria-hidden="true"></span><span class="cdk-visually-hidden" *ngIf="isSorted(IssueSortKeys.Severity)">{{ sortWordKey() | translate }}</span></button>
  </span>
  <span class="fr-asset">
    <button type="button" class="fr-hbtn" [class.sorted]="isSorted(IssueSortKeys.Asset)" [class.asc]="isSorted(IssueSortKeys.Asset) && sort?.dir === 'asc'"
            [disabled]="!sortEnabled"
            (click)="onSort(IssueSortKeys.Asset)"><span class="fr-hlabel">{{ '@asset' | translate }}</span><span class="fr-arrow" aria-hidden="true"></span><span class="cdk-visually-hidden" *ngIf="isSorted(IssueSortKeys.Asset)">{{ sortWordKey() | translate }}</span></button>
  </span>
  <span class="fr-where" *ngIf="showWhereColumn">
    <button type="button" class="fr-hbtn" [class.sorted]="isSorted(IssueSortKeys.Location)" [class.asc]="isSorted(IssueSortKeys.Location) && sort?.dir === 'asc'"
            [disabled]="!sortEnabled"
            (click)="onSort(IssueSortKeys.Location)"><span class="fr-hlabel">{{ '@currentLocation' | translate }}</span><span class="fr-arrow" aria-hidden="true"></span><span class="cdk-visually-hidden" *ngIf="isSorted(IssueSortKeys.Location)">{{ sortWordKey() | translate }}</span></button>
  </span>
  <span class="fr-issue">
    <button type="button" class="fr-hbtn" [class.sorted]="isSorted(IssueSortKeys.Problem)" [class.asc]="isSorted(IssueSortKeys.Problem) && sort?.dir === 'asc'"
            [disabled]="!sortEnabled"
            (click)="onSort(IssueSortKeys.Problem)"><span class="fr-hlabel">{{ '@issuesColIssue' | translate }}</span><span class="fr-arrow" aria-hidden="true"></span><span class="cdk-visually-hidden" *ngIf="isSorted(IssueSortKeys.Problem)">{{ sortWordKey() | translate }}</span></button>
  </span>
  <span class="fr-statecell">
    <button type="button" class="fr-hbtn" [class.sorted]="isSorted(IssueSortKeys.Lifecycle)" [class.asc]="isSorted(IssueSortKeys.Lifecycle) && sort?.dir === 'asc'"
            [disabled]="!sortEnabled"
            (click)="onSort(IssueSortKeys.Lifecycle)"><span class="fr-hlabel">{{ '@state' | translate }}</span><span class="fr-arrow" aria-hidden="true"></span><span class="cdk-visually-hidden" *ngIf="isSorted(IssueSortKeys.Lifecycle)">{{ sortWordKey() | translate }}</span></button>
  </span>
  <span class="fr-num">
    <button type="button" class="fr-hbtn" [class.sorted]="isSorted(IssueSortKeys.Signals)" [class.asc]="isSorted(IssueSortKeys.Signals) && sort?.dir === 'asc'"
            [disabled]="!sortEnabled"
            [title]="'@issuesColSignalsHint' | translate"
            (click)="onSort(IssueSortKeys.Signals)"><span class="fr-hlabel">{{ '@issuesColSignals' | translate }}</span><span class="fr-arrow" aria-hidden="true"></span><span class="cdk-visually-hidden" *ngIf="isSorted(IssueSortKeys.Signals)">{{ sortWordKey() | translate }}</span></button>
  </span>
  <span class="fr-conf">
    <button type="button" class="fr-hbtn" [class.sorted]="isSorted(IssueSortKeys.Confidence)" [class.asc]="isSorted(IssueSortKeys.Confidence) && sort?.dir === 'asc'"
            [disabled]="!sortEnabled"
            [title]="'@issuesColConfidenceHint' | translate"
            (click)="onSort(IssueSortKeys.Confidence)"><span class="fr-hlabel">{{ '@issuesColConfidence' | translate }}</span><span class="fr-arrow" aria-hidden="true"></span><span class="cdk-visually-hidden" *ngIf="isSorted(IssueSortKeys.Confidence)">{{ sortWordKey() | translate }}</span></button>
  </span>
  <span class="fr-age">
    <button type="button" class="fr-hbtn" [class.sorted]="isSorted(IssueSortKeys.Age)" [class.asc]="isSorted(IssueSortKeys.Age) && sort?.dir === 'asc'"
            [disabled]="!sortEnabled"
            [title]="'@issuesColOpenForHint' | translate"
            (click)="onSort(IssueSortKeys.Age)"><span class="fr-hlabel">{{ '@issuesColOpenFor' | translate }}</span><span class="fr-arrow" aria-hidden="true"></span><span class="cdk-visually-hidden" *ngIf="isSorted(IssueSortKeys.Age)">{{ sortWordKey() | translate }}</span></button>
  </span>
  <span class="fr-assigned" *ngIf="showCase">
    <button type="button" class="fr-hbtn" [class.sorted]="isSorted(IssueSortKeys.Assignee)" [class.asc]="isSorted(IssueSortKeys.Assignee) && sort?.dir === 'asc'"
            [disabled]="!sortEnabled"
            (click)="onSort(IssueSortKeys.Assignee)"><span class="fr-hlabel">{{ '@issuesColOwner' | translate }}</span><span class="fr-arrow" aria-hidden="true"></span><span class="cdk-visually-hidden" *ngIf="isSorted(IssueSortKeys.Assignee)">{{ sortWordKey() | translate }}</span></button>
  </span>
  <span class="fr-chev" aria-hidden="true"></span>
</div>

<button *ngIf="!header" type="button" class="issue-fr" [ngClass]="row.lifecycleCss"
        [class.panel]="isPanel"
        [class.submitting]="submitting" [class.selected]="selected"
        [class.working]="confirming"
        [attr.aria-selected]="selected" (click)="onOpen()">
  <!-- The same badge Service Center puts on an asset row and the asset card puts on an
       Issue, so one severity reads one way across the product. Fixed width, so the column
       holds its edge down the sheet and the tiers can be scanned rather than read. -->
  <app-severity-tag class="fr-sev" [severity]="row.severity" variant="list"></app-severity-tag>

  <span class="fr-asset" *ngIf="showsAsset" [title]="assetTitle">{{ row.assetName }}</span>

  <!-- Where the asset is now, which is a different question from the yard it belongs to.
       Tinted when it sits at a shop that is not one of its home locations: the scope said
       one place and the asset is in another, which is worth seeing rather than hiding. The
       whole column goes for a tenant that flags no shop geofences — see showWhere. -->
  <span class="fr-where" *ngIf="showWhere" [class.fr-away]="row.awayFromHome">
    <mat-icon class="fr-pin" aria-hidden="true">place</mat-icon>
    <span class="fr-wtext" *ngIf="namesShop"
          [title]="row.awayFromHome ? whereText + ' — ' + ('@issueAwayFromHome' | translate) : whereText">
      {{ whereText }}
      <!-- Away from home is a colour change on the pin, which a reader who cannot separate
           the two colours never receives. The text below is not shown; it is what a screen
           reader announces after the shop name. -->
      <span class="fr-sr" *ngIf="row.awayFromHome">{{ '@issueAwayFromHome' | translate }}</span>
    </span>
    <span class="fr-wtext fr-wstate" *ngIf="!namesShop">{{ whereStateKey | translate }}</span>
  </span>

  <span class="fr-issue">
    <span class="fr-title" [title]="problemTitle">{{ row.displayName }}</span>
    <span class="fr-desc" *ngIf="row.description" [title]="row.description">{{ row.description }}</span>
    <ng-container *ngIf="!confirming">
      <!-- The catalog's grouping, not the fingerprint. The slug identifies the problem
           but nobody scans a dotted identifier, so it lives in the tooltip. -->
      <span class="fr-category" *ngIf="row.category"
            [title]="'@issuesSystemTooltip' | translate: { name: row.category }">{{ row.category }}</span>
      <app-issue-tags [reopened]="row.reopened" [dvirOrigin]="row.dvirOrigin"></app-issue-tags>
      <!-- Unclaimed is a real state, not an empty cell — it is the thing a claim
           converts, so it reads as a badge rather than as missing data. -->
      <span *ngIf="showNoCase" class="fr-nocase">{{ '@issueNoCase' | translate }}</span>
    </ng-container>
    <!-- The user's own close, still in flight. 202 means published, not applied, so
         the row says it is waiting rather than pretending the Issue is gone. -->
    <span class="fr-wait" *ngIf="confirming">
      <span class="fr-spin" aria-hidden="true"></span>{{ '@issuesClosingWait' | translate }}
    </span>
  </span>

  <span class="fr-statecell">
    <app-lifecycle-chip [state]="row.lifecycleState"></app-lifecycle-chip>
  </span>

  <span class="fr-num" [attr.title]="(row.signalCount === 1 ? '@issueSignalCountOne' : '@issueSignalCount') | translate: { count: row.signalCount }">
    {{ row.signalCount }}
  </span>

  <span class="fr-conf" [class.muted]="row.confidenceMuted">{{ row.confidencePct }}%</span>

  <!-- How long it has been open. A duration, not a threshold: no age turns an Issue into
       a different kind of thing. -->
  <span class="fr-age">{{ ageLabel }}</span>

  <!-- Who holds the work. The assignee lives on the case, so the whole column goes with it
       for a tenant without the cases feature. -->
  <span class="fr-assigned" *ngIf="showCase">
    <app-owner-avatar *ngIf="row.assigneeInitials" [initials]="row.assigneeInitials"
                      [name]="row.assigneeName" [canMaintain]="false"></app-owner-avatar>
    <span *ngIf="!row.assigneeInitials" class="fr-av-none" aria-hidden="true">&ndash;</span>
  </span>

  <span class="fr-chev" aria-hidden="true">&rsaquo;</span>
</button>
